var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayCircle = function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.999 14.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D1FADF",
    d: "M6.332 5.977c0-.318 0-.477.067-.566a.33.33 0 0 1 .243-.133c.11-.008.244.078.512.25L10.3 7.551c.232.15.348.224.388.32a.33.33 0 0 1 0 .259c-.04.095-.156.17-.388.319l-3.147 2.023c-.268.172-.402.258-.512.25a.33.33 0 0 1-.243-.133c-.067-.089-.067-.248-.067-.566z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M7.999 14.667a6.667 6.667 0 1 0 0-13.334 6.667 6.667 0 0 0 0 13.334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M6.332 5.977c0-.318 0-.477.067-.566a.33.33 0 0 1 .243-.133c.11-.008.244.078.512.25L10.3 7.551c.232.15.348.224.388.32a.33.33 0 0 1 0 .259c-.04.095-.156.17-.388.319l-3.147 2.023c-.268.172-.402.258-.512.25a.33.33 0 0 1-.243-.133c-.067-.089-.067-.248-.067-.566z"
  })));
};
export default SvgPlayCircle;